// helper
import { isEmpty, RENDERING_DETAILS_TYPES } from "@swiggy-private/core-ui";

// Interfaces
import { IRewardWidgetHeader } from "@dineout-cart-ui/interfaces/Cart";
import { RenderingDetails } from "@swiggy-private/cart-types";

export const checkIfDiscountExists = (
    enteredAmount: number,
    discountedAmountRaw?: string,
    savingsText?: string,
): boolean => {
    return (
        (Number(enteredAmount) !== Number(discountedAmountRaw) &&
            Number(discountedAmountRaw) < Number(enteredAmount)) ||
        !isEmpty(savingsText)
    );
};

export const getStartAmount = (
    isRewardRedeemed: boolean,
    originalAmount: number,
    showTickerAnimation: boolean,
    previousTargetAmount: number,
): number => {
    if (!isRewardRedeemed) {
        return originalAmount;
    }
    return showTickerAnimation ? originalAmount : previousTargetAmount;
};

export const isRestaurantHaving2xDineCash = (
    rewardWidgetHeader?: IRewardWidgetHeader,
    isBooster?: boolean,
): boolean => {
    return !isEmpty(rewardWidgetHeader) && Boolean(isBooster);
};

export const isItemValueRupee = ({ meta = {}, key = "" }: RenderingDetails): boolean => {
    const _key = key.toUpperCase();
    const validRenderingDetailsTypes = [RENDERING_DETAILS_TYPES.GRAND_TOTAL];
    return isEmpty(meta) || validRenderingDetailsTypes.includes(_key);
};
